// extracted by mini-css-extract-plugin
export default {"google_signin":"e7zf3"};